import { Button } from "@minervaproject/fds";
import React from "react";

import { useAppSelector } from "hooks/redux_hooks";
import { useTimeout } from "hooks/use_timeout";
import { PageUnloadReasonType } from "shared/types";
import { classroomSelectors } from "store";
import { redirectToClassEditPage } from "utils/classroom";

function KickOutWarning({ hideModal }: { hideModal: () => void }) {
  const isMonitoringPage = window.location.pathname.startsWith("/monitoring");
  const classInfo = useAppSelector(classroomSelectors.selectClassInfo());
  const { clear } = useTimeout(() => {
    if (isMonitoringPage) {
      window.location.href = "/monitoring";
    } else {
      redirectToClassEditPage(
        { classId: classInfo.id, sectionId: classInfo.section.id, courseId: classInfo.course.id },
        PageUnloadReasonType.KICKED_OUT_OF_CLASS_INACTIVE_USER,
      );
    }
  }, 30000);

  const handleStayInClass = () => {
    clear();
    hideModal();
  };

  return (
    <div className="body" data-testid="kick-out-modal">
      <div>{`This class has ended. You will be redirected to the ${
        isMonitoringPage ? "main Monitoring Dashboard" : "dashboard"
      } in 30 seconds.`}</div>
      <Button type="button" mt={5} onClick={handleStayInClass}>
        {`Stay ${isMonitoringPage ? "Here" : "In Class"}`}
      </Button>
    </div>
  );
}

export { KickOutWarning };
